const nav = {
    aiScheduler: 'AI Planner (App Demo)',
    fileUpload: 'Bestand Uploaden (AWS S3)',
    documentation: 'Documentatie',
    blog: 'Blog',
    login: 'INLOGGEN',
    logout: 'UITLOGGEN',
    home: 'HOME',
    trips: 'REIZEN',
    products: 'Producten',
    cart: 'WINKELWAGEN',
    aboutUs: 'OVER ONS',
    myAccount: 'MIJN ACCOUNT',
    signUp: 'REGISTREREN',
    contacts: 'CONTACT'
};

export default nav;

